"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagPK = function FlagPK(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-87.07V-122H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-87.07,146.36h-98.87A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06h98.87Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M136.64,49.13A78.63,78.63,0,0,1,25.48,42.55,79,79,0,0,1,32.06-68.81a.86.86,0,0,1,.14-.13.91.91,0,0,0-.93-1.53A86,86,0,0,0-23.51,9.7a86,86,0,0,0,85.9,86.07,85.7,85.7,0,0,0,75.7-45.58.91.91,0,0,0-1.41-1.1l0,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M94.83-54.55l11.29,12.67,15.65-6.58a2.29,2.29,0,0,1,2.87,3.26l-8.57,14.66,11.1,12.84A2.29,2.29,0,0,1,125-14l-16.58-3.6L99.58-3a2.29,2.29,0,0,1-4.24-1L93.66-20.9,77.12-24.77a2.28,2.28,0,0,1-.39-4.32l15.54-6.83L90.84-52.84a2.29,2.29,0,0,1,4-1.71Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagPK;
exports["default"] = _default;